import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/mockData';
import { Quote } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const t = {
  fr: { label: 'Témoignages', h2a: 'Ce que disent', h2b: 'nos clients' },
  en: { label: 'Testimonials', h2a: 'What our', h2b: 'clients say' },
};

const TestimonialsSection = () => {
  const { lang } = useLang();
  const tx = t[lang];
  const items = testimonials[lang];

  return (
    <section className="relative py-24 md:py-32 bg-[#151515]">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-5xl mx-auto mb-16 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-6">
            <span className="text-sm uppercase tracking-widest text-[#717171] font-mono">{tx.label}</span>
          </motion.div>
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white mb-6 leading-tight">
            {tx.h2a}<br /><span className="text-[#d4a574]">{tx.h2b}</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {items.map((testimonial, index) => (
            <motion.div key={testimonial.id} initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-50px" }} transition={{ duration: 0.7, delay: index * 0.15, ease: "easeOut" }} whileHover={{ y: -8, transition: { duration: 0.3 } }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#d4a574]/30 transition-all duration-300">
              <div className="mb-6"><Quote className="text-[#d4a574] opacity-50" size={40} /></div>
              <p className="text-white/80 text-base md:text-lg leading-relaxed mb-6 italic">"{testimonial.text}"</p>
              <div className="flex items-center gap-4 pt-4 border-t border-white/10">
                <div className="flex-1">
                  <h4 className="text-white font-semibold">{testimonial.name}</h4>
                  <p className="text-white/50 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#d4a574]/5 rounded-full blur-3xl pointer-events-none" />
    </section>
  );
};

export default TestimonialsSection;
